import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IUploadImportFileDto } from 'common/src/types/importFile.dtos';
import { IImportFile, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS, formContentType } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getImportFileDownloadUrl = (id: string): string =>
  `${import.meta.env.VITE_API_URL}${API_BASE_PATHS.IMPORT_FILES}/${encodeURIComponent(id)}/download`;

export const getImportFiles = async (
  params?: DataQueryParams,
): Promise<IPage<IImportFile>> =>
  await getRequest(API_BASE_PATHS.IMPORT_FILES, formatQueryParams(params));

export const updateImportFile = async (
  id: string,
  body: Partial<IImportFile>,
): Promise<void> =>
  await patchRequest(`${API_BASE_PATHS.IMPORT_FILES}/${id}`, {}, body);

export const uploadImportFiles = async (
  payload: IUploadImportFileDto,
): Promise<string[]> =>
  await postRequest(
    `${API_BASE_PATHS.IMPORT_FILES}/upload`,
    {},
    payload,
    formContentType,
  );
